export const SITE_ORIGIN = 'https://www.santtai.com';

export const DEFAULT_OG_IMAGE =
  'https://imagedelivery.net/KQLaZdBjDzxarhwBRuqRFg/e688aa15-3a85-4e4b-5925-4526ffeeda00/public';

export const COUNTRY_SLUGS = [
  'indonesia',
  'maldives',
  'thailand',
  'myanmar',
  'micronesia',
  'mexico',
] as const;

export type CountrySlug = (typeof COUNTRY_SLUGS)[number];

export const BOAT_SLUGS = [
  'mv-tapana-catamaran',
  'mv-issara',
  'aruna-odyssey',
  'aruna-voyager',
  'mv-raga',
  'mv-aquarian',
  'vela-liveaboard',
  'mv-ambai',
  'summer-liveaboard',
  'wunderpus-liveaboard',
  'my-black-pearl',
  'my-white-pearl',
  'msy-seahorse',
] as const;

export const STATIC_SITEMAP_PATHS = [
  '/',
  '/privacypolicy',
  '/guides/thailand',
] as const;
